import React from 'react';

import classNames from 'classnames/bind';
import styles from './Button.scss';
const cx = classNames.bind(styles);

const Button = React.memo(
  ({
    type = '',
    tabIndex = '0',
    name = '',
    disabled = false,
    className = [],
    style = {},
    onClick,
    children,
  }) => {
    return (
      <button
        tabIndex={tabIndex}
        type={type}
        className={cx('Button', 'btn', ...className)}
        onClick={onClick}
        style={style}
        disabled={disabled}
      >
        {name ? <span className="name">{name}</span> : null}
        {children}
      </button>
    );
  },
);

export default Button;
